import * as React from 'react';
export const IcCare = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.71 13.29a1.002 1.002 0 00-1.42 0L16.59 16H14a1 1 0 000-2H7.83a2 2 0 00-1.42.59l-3.12 3.12a1 1 0 00-.29.7V21a1 1 0 001 1h.59a1 1 0 00.7-.29l1.42-1.42a1 1 0 01.7-.29h7.18a2 2 0 001.41-.59l4.71-4.7a1.002 1.002 0 000-1.42zm-9.57-1.75l.22.21A.92.92 0 0012 12a.9.9 0 00.63-.25l.23-.21c2.14-2 3.38-3.4 3.38-5A2.53 2.53 0 0013.69 4a2.62 2.62 0 00-1.69.69A2.62 2.62 0 0010.31 4a2.53 2.53 0 00-2.55 2.56c0 1.58 1.24 3.02 3.38 4.98z'
      fill='currentColor'
    />
  </svg>
);
